import React, { useEffect, useState } from 'react';
import { Col, Row, Tab, Tabs } from 'react-bootstrap';
import {
  fetchMatchDays,
  fetchTopPlayers,
  fetchRoundRecords,
} from '../util/api/requests';
import MatchDaysDataTable from './datatables/MatchDaysDataTable';
import TopPlayersDataTable from './datatables/TopPlayersDataTable';
import { renderSpinner } from '../util/util';
import '../style/RecordsTable.css';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import {
  createDateFromBackendDate,
  getCurrentDateWithZeroTime,
} from '../util/dateUtil';

const MatchDays = ({ leagueId, currentSeason }) => {
  const [matchDays, setMatchDays] = useState([]);
  const [topPlayers, setTopPlayers] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState({
    matchDays: false,
    topPlayers: false,
    roundRecords: false,
  });

  useEffect(() => {
    if (!leagueId) return;

    const loadData = async () => {
      setLoading((prev) => ({
        ...prev,
        matchDays: true,
        topPlayers: true,
        roundRecords: true,
      }));

      try {
        const matchDaysData = await fetchMatchDays(leagueId);
        if (matchDaysData) setMatchDays(matchDaysData);
      } catch (error) {
        console.error('Failed to load match days:', error);
      } finally {
        setLoading((prev) => ({ ...prev, matchDays: false }));
      }

      try {
        const topPlayersData = await fetchTopPlayers(leagueId);
        if (topPlayersData) setTopPlayers(topPlayersData);
      } catch (error) {
        console.error('Failed to load top players:', error);
      } finally {
        setLoading((prev) => ({ ...prev, topPlayers: false }));
      }

      try {
        const roundRecordsData = await fetchRoundRecords(leagueId);
        if (roundRecordsData) setRecords(roundRecordsData.records);
      } catch (error) {
        console.error('Failed to load round records:', error);
      } finally {
        setLoading((prev) => ({ ...prev, roundRecords: false }));
      }
    };

    loadData();
  }, [leagueId]);

  const currentlyActiveMatch = () => {
    const currentDate = getCurrentDateWithZeroTime();
    return matchDays.reduce((highest, matchDay) => {
      const startDate = createDateFromBackendDate(matchDay.matchDayStartDate);
      const endDate = createDateFromBackendDate(matchDay.matchDayEndDate);
      return startDate <= currentDate && endDate >= currentDate
        ? matchDay.id
        : highest;
    }, 0);
  };

  if (loading.matchDays || loading.topPlayers || loading.roundRecords) {
    return <div className="mt-5">{renderSpinner()}</div>;
  }
  if (!leagueId || matchDays.length === 0 || records.length === 0) {
    return null;
  }

  return (
    <Tabs
      className="nav_tabs nav_tabs_clickable"
      defaultActiveKey={currentlyActiveMatch()}
      id="match-day-tabs"
    >
      {matchDays.map((matchDay) => (
        <Tab
          key={matchDay.id}
          eventKey={matchDay.id}
          title={matchDay.matchDayNo}
        >
          <Row>
            <Col lg={12} xs={12}>
              <MatchDaysDataTable matchDayMatches={matchDay.matches} />
            </Col>
            <Col lg={6} xs={12}>
              <h6>Vooru TOP</h6>
            </Col>
            <Col lg={6} xs={12}>
              <h6>Rekordid</h6>
            </Col>
            <Col lg={6} xs={12}>
              <TopPlayersDataTable
                topPlayers={topPlayers.find(
                  (e) => e.roundNo === matchDay.matchDayNo
                )}
              />
            </Col>
            <Col lg={6} xs={12}>
              {renderRoundRecords(records, matchDay, currentSeason)}
            </Col>
          </Row>
        </Tab>
      ))}
    </Tabs>
  );
};

const renderRoundRecords = (records, matchDay, currentSeason) => {
  const roundRecord = records.find(
    (e) => e.roundNo === matchDay.matchDayNo && e.seasonId === currentSeason?.id
  );
  if (!roundRecord) return null;

  return (
    <MDBTable striped className="recordsTable">
      <MDBTableHead>
        <tr>
          <th>Kodus</th>
          <th></th>
          <th>Võõrsil</th>
          <th></th>
        </tr>
      </MDBTableHead>
      <MDBTableBody>
        <tr>
          <td>{roundRecord.homeSetRecordPlayerName}</td>
          <td>{roundRecord.homeSetRecordScore}</td>
          <td>{roundRecord.awaySetRecordPlayerName}</td>
          <td>{roundRecord.awaySetRecordScore}</td>
        </tr>
        <tr>
          <td>{roundRecord.homeRoundRecordTeamName}</td>
          <td>{roundRecord.homeRoundRecordScore}</td>
          <td>{roundRecord.awayRoundRecordTeamName}</td>
          <td>{roundRecord.awayRoundRecordScore}</td>
        </tr>
      </MDBTableBody>
    </MDBTable>
  );
};

export default MatchDays;
